var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-doc-preview',{attrs:{"docName":"Pré-visualizar documento","name":"contracts-model-preview","url":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }